import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const ROWS = [
  { label: "Accès aux espaces exigus (sous-sols, places serrées)", s360: true, classic: false },
  { label: "Déplacement sans clé ni démarrage du véhicule", s360: true, classic: false },
  { label: "Aucun risque de rayure ou de dommage", s360: true, classic: false },
  { label: "Extinction intégrée des feux de véhicules", s360: true, classic: false },
  { label: "Mise en œuvre par un seul opérateur", s360: true, classic: false },
  { label: "Encombrement et coût d'exploitation élevés", s360: false, classic: true },
];

export default function Comparison() {
  return (
    <section data-testid="comparison-section" className="py-24 lg:py-32 bg-white border-t border-zinc-200">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="font-mono-tech text-sm uppercase tracking-[0.2em] text-[#E63946] font-semibold">Comparatif</p>
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            Sapeur-360 vs méthode classique.
          </h2>
          <p className="mt-4 text-lg text-[#52525B]">
            Face à une grue ou une dépanneuse traditionnelle, Sapeur-360 change la donne.
          </p>
        </div>

        <div className="mt-12 border border-zinc-200 rounded-sm overflow-hidden">
          <div className="grid grid-cols-[1fr_auto_auto] bg-[#0A0A0A] text-white">
            <div className="p-4 font-mono-tech text-xs uppercase tracking-wider text-white/60">Critère</div>
            <div className="p-4 w-28 text-center font-display font-bold">Sapeur-360</div>
            <div className="p-4 w-28 text-center font-mono-tech text-xs uppercase tracking-wider text-white/60">Grue / dépanneuse</div>
          </div>
          {ROWS.map((r, i) => (
            <motion.div key={r.label}
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className={`grid grid-cols-[1fr_auto_auto] items-center ${i % 2 ? "bg-[#FAFAFA]" : "bg-white"} border-t border-zinc-200`}>
              <div className="p-4 text-sm text-[#0A0A0A]">{r.label}</div>
              <div className="p-4 w-28 flex justify-center">
                {r.s360 ? <Check className="h-5 w-5 text-[#10B981]" strokeWidth={2.5} /> : <X className="h-5 w-5 text-zinc-300" />}
              </div>
              <div className="p-4 w-28 flex justify-center">
                {r.classic ? <Check className="h-5 w-5 text-[#10B981]" strokeWidth={2.5} /> : <X className="h-5 w-5 text-zinc-300" />}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
